import React, { useMemo } from "react";
import { motion } from "framer-motion";
import resources from "../../resources/Content";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const ClientsSection = () => {
  // CMS binding
  const { clients } = resources.about;

  // stable reference
  const columns = useMemo(() => clients.columns, [clients.columns]);

  return (
    <section
      className="relative w-full text-white bg-cover bg-center bg-fixed overflow-hidden border-t border-neutral-800"
      style={{ backgroundImage: `url(${clients.background})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-24">

        {/* Header */}
        <div className="relative z-10 mb-10 sm:mb-14">

          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 sm:gap-6">

            {/* Left */}
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.25em] text-neutral-300 leading-tight">
              <p>{clients.header.left.index}</p>
              <p>{clients.header.left.label}</p>
            </div>

            {/* Center */}
            <h3 className="
              font-bold text-white/30 leading-none select-none pointer-events-none
              text-[clamp(2.5rem,12vw,12.5rem)]
              text-center
            ">
              {clients.header.title}
            </h3>

            {/* Right */}
            <p className="
              text-[10px] sm:text-sm text-neutral-300
              text-center sm:text-right
              whitespace-normal sm:whitespace-nowrap
            ">
              {clients.header.right}
            </p>

          </div>
        </div>

        {/* GRID */}
        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-3 gap-6">

          {columns.map((column, colIndex) => (
            <div key={colIndex} className="flex flex-col gap-6">

              {column.map((item) => (
                <ProjectCard key={item.id} {...item} />
              ))}

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

const ProjectCard = ({ number, title, year, subtitle, image, aspect }) => (
  <motion.a
    href="#"
    className="group border border-white/20 bg-gray-700/40 backdrop-blur-md overflow-hidden cursor-pointer rounded-lg"
    variants={cardVariants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
  >
    {/* IMAGE */}
    <div className="relative">
      <p className="absolute top-3 left-4 text-xs tracking-[0.2em] text-neutral-300">
        {number}
      </p>

      <div className={`relative w-full ${aspect} overflow-hidden`}>
        <img
          src={image}
          alt={title}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover transform transition-transform duration-[800ms] ease-[cubic-bezier(.22,.61,.36,1)] group-hover:scale-[1.08]"
        />
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition duration-500" />
      </div>
    </div>

    {/* TEXT */}
    <div className="flex items-center justify-between px-5 py-4 border-t border-white/10">
      <div>
        <h3 className="text-base sm:text-lg font-semibold leading-none">
          {title}
        </h3>
        <p className="text-xs text-neutral-300 mt-2">{subtitle}</p>
      </div>
      <p className="text-xs text-neutral-300">{year}</p>
    </div>
  </motion.a>
);

export default ClientsSection;